// extracted by mini-css-extract-plugin
export default {"PanelHeaderPagehead":"PanelHeader-module__PanelHeaderPagehead--Ju_I0","PanelHeaderSubtitle":"PanelHeader-module__PanelHeaderSubtitle--RgwC9"};